if (!customElements?.get('price-range')) {
  // price-range is already defined in facets.js, so we just enhance it
}

document.addEventListener('DOMContentLoaded', function () {
  initPriceRangeSliders();
});

// Re-init after facet filter AJAX updates — guard against duplicate declarations
if (typeof window._priceRangeSliderPatched === 'undefined') {
  window._priceRangeSliderPatched = true;

  const originalRenderProductGridContainer = FacetFiltersForm.renderProductGridContainer;
  FacetFiltersForm.renderProductGridContainer = function (html) {
    originalRenderProductGridContainer(html);
  };

  const originalRenderFilters = FacetFiltersForm.renderFilters;
  FacetFiltersForm.renderFilters = function (html, event) {
    originalRenderFilters(html, event);
    setTimeout(initPriceRangeSliders, 50);
  };
}

function initPriceRangeSliders() {
  document.querySelectorAll('.price-range-slider').forEach((slider) => {
    if (slider.dataset.initialized) return;
    slider.dataset.initialized = 'true';

    const minInput = slider.querySelector('.price-range-slider__input--min');
    const maxInput = slider.querySelector('.price-range-slider__input--max');
    const trackActive = slider.querySelector('.price-range-slider__track-active');
    const minDisplay = slider.querySelector('[id$="price-min-display"]');
    const maxDisplay = slider.querySelector('[id$="price-max-display"]');

    if (!minInput || !maxInput) return;

    const priceRange = slider.closest('price-range');
    const textInputs = priceRange ? priceRange.querySelectorAll('.field__input') : [];
    const minTextInput = textInputs[0];
    const maxTextInput = textInputs[1];
    const rangeMax = parseFloat(slider.dataset.rangeMax) || 100;
    const currencySymbol = minDisplay ? minDisplay.textContent.replace(/[\d.,\s]/g, '') : '$';

    function updateTrack() {
      const min = parseFloat(minInput.value);
      const max = parseFloat(maxInput.value);
      const percentMin = (min / rangeMax) * 100;
      const percentMax = (max / rangeMax) * 100;
      trackActive.style.left = percentMin + '%';
      trackActive.style.right = (100 - percentMax) + '%';

      if (minDisplay) minDisplay.textContent = currencySymbol + Math.floor(min);
      if (maxDisplay) maxDisplay.textContent = currencySymbol + Math.ceil(max);
    }

    function syncToTextInputs() {
      if (minTextInput) {
        minTextInput.value = Math.floor(parseFloat(minInput.value));
      }
      if (maxTextInput) {
        maxTextInput.value = Math.ceil(parseFloat(maxInput.value));
      }
    }

    let debounceTimer;
    function onSliderInput() {
      let minVal = parseFloat(minInput.value);
      let maxVal = parseFloat(maxInput.value);

      // Prevent thumbs from crossing
      if (minVal > maxVal) {
        if (this === minInput) {
          minInput.value = maxVal;
        } else {
          maxInput.value = minVal;
        }
      }

      updateTrack();
      syncToTextInputs();

      // Debounce the actual filter trigger
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (minTextInput) {
          minTextInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 500);
    }

    minInput.addEventListener('input', onSliderInput);
    maxInput.addEventListener('input', onSliderInput);

    // Sync text inputs back to sliders
    if (minTextInput) {
      minTextInput.addEventListener('change', function () {
        const val = parseFloat(this.value) || 0;
        minInput.value = val;
        updateTrack();
      });
    }
    if (maxTextInput) {
      maxTextInput.addEventListener('change', function () {
        const val = parseFloat(this.value) || rangeMax;
        maxInput.value = val;
        updateTrack();
      });
    }

    updateTrack();
  });
}
